<form (ngSubmit)="onSubmit()" [formGroup]="formGroup"*ngIf="mindSpecialties.length > 0 && bodySpecialties.length > 0">
  <div class="zaya-form-header" i18n="label|Indicates where practitioner will enter their services.@@labelYourServices">Your therapies & services</div>
  <div class="d-flex flex-fill justify-content-center mb-4 zaya-form-help-text text-center" i18n="label|Help text for the services a practitioner offers.@@labelApplicationServicesHelpText">
    Please enter the name of the therapy you offer along with the services you offer under that therapy. If you offer more than one service under that therapy, click the + Add another service button
    along with the corresponding costs and length of each session. Once you have finished entering one service, click the "+add another service" button to add the next service. If you offer more than
    one therapy, e.g. you offer massage and acupuncture, make sure to add another therapy. Make sure to double check your spelling and grammar. For example: instead of typing "massage therapy", type
    "Massage Therapy".
  </div>

  <div class="card" *ngFor="let specialtyControl of getControls('specialties'); let i = index;" [class.mt-3]="i > 0">
    <div class="card-body">
      <div>
        <div class="d-flex flex-fill mb-4 zaya-form-help-text" i18n="label|Help text for the therapy type of a practitioner.@@labelApplicationTherapyTypeHelpText">
          Please choose the category that your therapy belongs to. "Mind" refers to practitioners that specialize in mental health for ex. Psychotherapy.
          "Body" refers to practitioners that specialize in physical health for ex. Acupuncture.
        </div>
        <div class="row">
          <div class="col-xs-12 col-md-3">
            <div formArrayName="categories">
              <label for="category{{i}}" class="zaya-form-sub-header" i18n="label|The category of the specialty a practitioner practices.@@labelSpecialtyCategory">Therapy Category</label>
              <select id="categorySelect{{i}}" name="category{i}}" class="form-control" (change)="updateSpecialtyCategory(i, $event.target.value)">
                <option value="body">Body</option>
                <option value="mind">Mind</option>
              </select>
              <input id="category{{i}}" type="text" class="form-control col-xs-12 col-md-6 mt-3" [formControlName]="i" hidden>
              <span
                class="help-block"
                *ngIf="i == 0 && formGroup.get('categories.0').invalid && formGroup.get('categories.0').touched"
                i18n="error message|The message shown when a therapy category has not been entered.@@errorTherapyCategory">
                  Please enter at least 1 therapy category.
              </span>
            </div>
          </div>
          <div class="col-xs-12 col-md-9 form-group">
            <div formArrayName="specialties">
              <label for="specialty{{i}}" class="zaya-form-sub-header" i18n="label|The specialty a practitioner practices.@@labelSpecialty">Therapy you offer e.g. Massage</label>
              <select id="nameSelect{{i}}" class="form-control" (change)="updateSpecialty(i, $event.target.value)">
                <option *ngFor="let specialty of formGroup.get('categories.' + i).value === 'mind' ? mindSpecialties : bodySpecialties" [value]="specialty">
                  {{specialty}}
                </option>
              </select>
              <input id="specialty{{i}}" type="text" class="form-control col-xs-12 col-md-6 mt-3" [formControlName]="i" hidden>
              <div class="text-right" *ngIf="i > 0">
                <span class="zaya-form-link" (click)="onRemoveControl('specialties', i); onRemoveControl('specialtyData', i); onRemoveControl('categories', i);">
                  x <ng-container i18n="button|Used to remove a specialty.@@buttonRemoveSpecialty"></ng-container>Remove this therapy
                </span>
              </div>
              <span
                class="help-block"
                *ngIf="i == 0 && formGroup.get('specialties.0').invalid && formGroup.get('specialties.0').touched"
                i18n="error message|The message shown when a specialty has not been entered.@@errorSpecialty">
                  Please enter at least 1 therapy.
              </span>
            </div>
          </div>
        </div>
        <div formArrayName="specialtyData">
          <div formGroupName="{{i}}" *ngFor="let therapyControl of getControls('specialtyData.' + i + '.therapies'); let j = index;">
            <hr *ngIf="j > 0">
            <div class="row">
              <div class="col-xs-12 col-md-6 form-group">
                <div formArrayName="therapies">
                  <label for="therapy{{j}}" class="zaya-form-sub-header" i18n="label|The therapy corresponding to a practitioner specialty.@@labelTherapy">
                    Service(s) you offer under this therapy e.g. Deep Tissue
                  </label>
                  <input id="therapy{{j}}" type="text" class="form-control" [formControlName]="j">
                  <span
                    class="help-block"
                    *ngIf="j == 0 && formGroup.get('specialtyData.' + i + '.therapies.' + j).invalid && formGroup.get('specialtyData.' + i + '.therapies.' + j).touched"
                    i18n="error message|The message shown when a therapy has not been entered.@@errorTherapy">
                      Please enter a valid service.
                  </span>
                  <div class="text-right" *ngIf="j > 0">
                    <span class="zaya-form-link" (click)="onRemoveControl('specialtyData.' + i + '.therapies', j); onRemoveControl('specialtyData.' + i + '.costs', j); onRemoveControl('specialtyData.' + i + '.descriptions', j); onRemoveControl('specialtyData.' + i + '.durations', j);">
                      x <ng-container i18n="button|Used to remove a therapy the user has entered.@@buttonRemoveTherapy">Remove this service</ng-container>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-12 form-group">
                <div formArrayName="descriptions">
                  <label for="description{{j}}" class="zaya-form-sub-header" i18n="label|The description of a practitioner service.@@labelTherapyDescription">Brief description of this service</label>
                  <textarea id="description{{j}}" cols="30" rows="4" class="form-control" [formControlName]="j" maxlength="300"></textarea>
                  <div class="zaya-form-help-text text-right">
                    {{ formGroup.value.specialtyData[i].descriptions[j] ? formGroup.value.specialtyData[i].descriptions[j].length : 0 }} / 300
                  </div>
                  <span
                    class="help-block"
                    *ngIf="j == 0 && formGroup.get('specialtyData.' + i + '.descriptions.' + j).invalid && formGroup.get('specialtyData.' + i + '.descriptions.' + j).touched"
                    i18n="error message|The message shown when a therapy description has not been entered.@@errorTherapyDescription">
                      Please enter a valid description.
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-6 form-group">
                <div formArrayName="costs">
                  <label for="cost{{j}}" class="zaya-form-sub-header" i18n="label|The price of a practitioner service.@@labelCost">Cost of service</label>
                  <div class="input-group">
                    <input id="cost{{j}}" type="number" class="form-control" [formControlName]="j">
                  </div>
                  <span
                    class="help-block"
                    *ngIf="j == 0 && formGroup.get('specialtyData.' + i + '.costs.' + j).invalid && formGroup.get('specialtyData.' + i + '.costs.' + j).touched"
                    i18n="error message|The message shown when a cost has not been entered.@@errorCost">
                      Please enter a valid cost.
                  </span>
                </div>
              </div>
              <div class="col-xs-12 col-md-6 form-group">
                <div formArrayName="durations">
                  <label for="duration{{j}}" class="zaya-form-sub-header" i18n="label|The duration of a practitioner service.@@labelDuration">Duration of service in minutes</label>
                  <div class="input-group">
                    <input id="duration{{j}}" type="number" class="form-control" [formControlName]="j">
                  </div>
                  <span
                    class="help-block"
                    *ngIf="j == 0 && formGroup.get('specialtyData.' + i + '.durations.' + j).invalid && formGroup.get('specialtyData.' + i + '.durations.' + j).touched"
                    i18n="error message|The message shown when a duration has not been entered.@@errorDuration">
                      Please enter a valid duration.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center" style="margin-bottom: 10px;">
            <span
              class="zaya-form-link"
              (click)="onAddControl('specialtyData.' + i + '.therapies'); onAddControl('specialtyData.' + i + '.costs'); onAddControl('specialtyData.' + i + '.descriptions'); onAddControl('specialtyData.' + i + '.durations');">
              + <ng-container i18n="button|Used to add a therapy.@@buttonAddTherapy">Add another service for this therapy</ng-container>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="text-center mt-3" style="margin-bottom: 10px;">
    <span
      class="zaya-form-link"
      (click)="onAddControl('categories'); onAddControl('specialties'); onAddSpecialtyDataControl();">
      + <ng-container i18n="button|Used to add a specialty.@@buttonAddSpecialty">Add another therapy you offer</ng-container>
    </span>
  </div>

  <hr>

  <div class="d-flex flex-fill justify-content-center">
    <button type="submit" class="btn btn-primary modal-btn mr-2" [disabled]="!formGroup.valid || isLoading">Submit</button>
    <button type="button" class="btn btn-secondary modal-btn" (click)="onDismiss()">Cancel</button>
  </div>
</form>
